// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2T8Fu","inputWrap":"styles_inputWrap__50tGS","input":"styles_input__-cd0T"};